<script>
import { mapActions, mapState } from 'vuex'

import ButtonTopology from './button-topology.vue'
import ButtonTopologyClone from './button-topology-clone.vue'
import ButtonTopologyShare from './button-topology-share.vue'
import ButtonTopologyDelete from './button-topology-delete.vue'
import TopologyVerticalDiagram from './topology/TopologyVerticalDiagram.vue'

export default {
  components: {
    ButtonTopology,
    ButtonTopologyClone,
    ButtonTopologyShare,
    ButtonTopologyDelete,
    TopologyVerticalDiagram
  },

  data: function () {
    return {
      step: 1,
      totalSteps: 4,
    }
  },

  props: {
    id: {
      type: Number,
      default: 0
    },
  },

  mounted () {
    this.getImageTiers()
    this.getTopologyLocations()
    let payload = { id: this.id }
    this.getTopologyBlueprint(payload)
  },

  methods: {
    ...mapActions([
      'getImageTiers',
      'getTopologyBlueprint',
      'getTopologyLocations',
      'patchTopologyBlueprint',
      'patchTopologyImage',
      'patchTopologyLocation',
      'patchTopologyWanPathCount',
      'postTopologyGroup'
    ]),

    isStep: function (step) {
      return step == this.step
    },

    isNotStep: function (step) {
      return step != this.step
    },

    isCompletedStep: function (step) {
      return step < this.step
    },

    nextStep: function () {
      this.step = Math.min(this.step+1, this.totalSteps)
      this.scrollToTop()
    },

    previousStep: function () {
      this.step = Math.max(this.step-1, 0)
      this.scrollToTop()
    },

    setStep: function (step) {
      this.step = Math.min(Math.max(step, 0), this.totalSteps)
      this.scrollToTop()
    },

    scrollToTop: function () {
      $('html, body').animate({ scrollTop: 0 })
    },

    patchTopologyBlueprintName: _.debounce(function (event) {
      if(event.target.value == '') {
        return
      }

      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'blueprint_name': event.target.value
        },
        self: this,
      }

      this.patchTopologyBlueprint(payload)
    }, 1000),

    patchTopologyBlueprintAlias: _.debounce(function (event) {
      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'blueprint_name': this.topology_blueprint.attributes.blueprint_name,
          'blueprint_alias': event.target.value
        },
        self: this,
      }

      this.patchTopologyBlueprint(payload)
    }, 1000),

    patchTopologyBlueprintDescription: _.debounce(function (event) {
      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'blueprint_name': this.topology_blueprint.attributes.blueprint_name,
          'blueprint_description': event.target.value
        },
        self: this,
      }

      this.patchTopologyBlueprint(payload)
    }, 1000),

    patchTopologyBlueprintNotes: _.debounce(function (event) {
      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'blueprint_name': this.topology_blueprint.attributes.blueprint_name,
          'blueprint_notes': event.target.value
        },
        self: this,
      }

      this.patchTopologyBlueprint(payload)
    }, 1000),

    selectLocation: function (event) {
      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'topology_location_id': event.target.value
        },
        self: this,
      }

      this.patchTopologyLocation(payload)
    },

    selectWanPathCount: function (event) {
      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'blueprint_name': this.topology_blueprint.attributes.blueprint_name,
          'blueprint_wan_path_count': event.target.value
        },
        self: this,
      }

      this.patchTopologyWanPathCount(payload)
    },

    selectImageGroup: function (image_group_id) {
      let image_group = this.image_groups.find(
          g => g.id == image_group_id
        )

      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'topology_blueprint_id': this.topology_blueprint.id,
          'image_group_id': image_group.id,
          'image_tier_id': image_group.attributes.image_tier_id
        },
        self: this,
      }

      this.postTopologyGroup(payload)
    },

    selectImageFlavor: function (image, event) {
      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'topology_blueprint_id': this.topology_blueprint.id,
          'topology_image_id': image.topology_image.id,
          'image_flavor_id': event.target.value
        },
        self: this,
      }

      this.patchTopologyImage(payload)
    },

    selectImageSnapshot: function (image, event) {
      let payload = {
        id: this.topology_blueprint.id,
        json: {
          'topology_blueprint_id': this.topology_blueprint.id,
          'topology_image_id': image.topology_image.id,
          'image_flavor_id': image.topology_image.attributes.image_flavor_id,
          'image_snapshot_id': event.target.value
        },
        self: this,
      }

      this.patchTopologyImage(payload)
    },

    isActiveImageGroup: function (image_group_id) {
      return this.topology_groups.find(
        n => n.attributes.image_group_id == image_group_id
      ) != undefined
    },

    isRemoteAccess: function (name) {
      return name == window.Labstack.rdp_computer_name
    },

    diagramBackground: function (group) {
      return "background-image: url('/images/topologies/" +
        group.attributes.group_alias +
        "-tile.png');"
    },

    diagramImage: function (group) {
      return "/images/topologies/" +
        group.attributes.group_alias +
        "-preview.png"
    },

    imageGroupByTier: function (tier_id) {
      let topology_group = this.topology_groups
        .find(
          g => g.attributes.image_tier_id == tier_id
        )

      return this.image_groups.find(
        g => g.id == topology_group.attributes.image_group_id
      )
    },

    imagesByTier: function (tier_id) {
      return this.topology_images.map(function(topology_image) {
        let image_blueprint = this.image_blueprints.find(
          b => b.id == topology_image.attributes.image_blueprint_id
        )

        return {
          'topology_image' : topology_image,
          'image_blueprint' : image_blueprint
        }
      }, this)
      .filter(function (image) {
        return image.image_blueprint.attributes.image_tier_id == tier_id
      })
      .sort(function(a, b) {
          let textA = a.image_blueprint.attributes.blueprint_name.toUpperCase()
          let textB = b.image_blueprint.attributes.blueprint_name.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
      })
    },

    imageFlavorsForBlueprint: function (imageBlueprintId) {
      return _.chain(this.image_flavors)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_blueprint_id == imageBlueprintId
        })
        // Order by column and direction
        .orderBy(['attributes.flavor_name'], ['asc'])
        .value()
    },

    mySnapshotsForFlavor: function (imageFlavorId) {
      return _.chain(this.image_snapshots)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_flavor_id == imageFlavorId &&
            // item.attributes.reservation_save_id == 0 &&
            item.attributes.published_at == null &&
            item.attributes.account_user_id == window.Labstack.user_id
        })
        // Order by column and direction
        .orderBy(['attributes.snapshot_name'], ['asc'])
        .value()
    },

    publishedSnapshotsForFlavor: function (imageFlavorId) {
      return _.chain(this.image_snapshots)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_flavor_id == imageFlavorId &&
            // item.attributes.reservation_save_id == 0 &&
            item.attributes.published_at != null
        })
        // Order by column and direction
        .orderBy(['attributes.snapshot_name'], ['asc'])
        .value()
    },
  },

  computed: {
    ...mapState({
      image_blueprints: state =>
        state.image.image_blueprints,
      image_flavors: state =>
        state.image.image_flavors,
      image_groups: state =>
        state.image.image_groups,
      image_snapshots: state =>
        state.image.image_snapshots,
      image_tiers: state =>
        state.image.image_tiers,
      topology_blueprint: state =>
        state.topology.topology_blueprints.find(
          t => t.id == state.topology.editor.id
        ),
      topology_categories: state =>
        state.topology.topology_categories,
      editor: state =>
        state.topology.editor,
      topology_groups: state =>
        state.topology.topology_groups.filter(
          g => g.attributes.topology_blueprint_id == state.topology.editor.id
        ),
      topology_images: state =>
        state.topology.topology_images.filter(
          i => i.attributes.topology_blueprint_id == state.topology.editor.id
        ),
      topology_locations: state =>
        state.topology.topology_locations,
    }),

    isVisible: function () {
      return this.editor.is_visible && this.topology_blueprint != undefined
    },

    topologyCategory: function () {
      return this.topology_categories.find(
          g => g.id == this.topology_blueprint.attributes.topology_category_id
        )
    },

    totalWanConnections: function () {
      return this.topology_blueprint.attributes.blueprint_wan_path_count
    },

    branchLocation: function () {
      return this.topology_locations.find(
        l => l.id == this.topology_blueprint.attributes.topology_location_id
      )
    },

    branchImageTiers: function () {
      return _.chain(this.image_tiers)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.tier_type == 'Branch'
        })
        // Order by column and direction
        .orderBy(['attributes.tier_alias'], ['desc'])
        .value()
    },

    branchNetwork: function () {
      return this.imageGroupByTier(1)
    },

    branchNetworkImage: function () {
      return this.diagramImage(
        this.branchNetwork
      )
    },

    branchNetworkImageGroups: function () {
      return _.chain(this.image_groups)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_tier_id == 1
        })
        // Filter by wan path count
        .filter(function (item) {
          return item.attributes.group_wan_path_count == this.topology_blueprint.attributes.blueprint_wan_path_count
        }.bind(this))
        // Order by column and direction
        .orderBy(['attributes.group_display_order'], ['asc'])
        .value()
    },

    branchOptimization: function () {
      return this.imageGroupByTier(2)
    },

    branchOptimizationImage: function () {
      return this.diagramImage(
        this.branchOptimization
      )
    },

    branchOptimizationImageGroups: function () {
      return _.chain(this.image_groups)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_tier_id == 2
        })
        // Filter by wan path count
        .filter(function (item) {
          return item.attributes.group_lan_path_count == this.branchNetwork.attributes.group_lan_path_count
        }.bind(this))
        // Order by column and direction
        .orderBy(['attributes.group_display_order'], ['asc'])
        .value()
    },

    branchHostImageGroups: function () {
      return _.chain(this.image_groups)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_tier_id == 3
        })
        // Order by column and direction
        .orderBy(['attributes.group_display_order'], ['asc'])
        .value()
    },

    wanImage: function () {
      if(this.topology_blueprint.attributes.blueprint_wan_path_count == 2) {
        return "/images/topologies/wan-mpls-internet.png"
      }

      return "/images/topologies/wan-mpls.png"
    },

    wanImageTiers: function () {
      return _.chain(this.image_tiers)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.tier_type == 'WAN'
        })
        // Order by column and direction
        .orderBy(['attributes.tier_alias'], ['asc'])
        .value()
    },

    datacenterNetwork: function () {
      return this.imageGroupByTier(5)
    },

    datacenterNetworkImage: function () {
      return this.diagramImage(
        this.datacenterNetwork
      )
    },

    datacenterImageTiers: function () {
      return _.chain(this.image_tiers)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.tier_type == 'Datacenter'
        })
        // Order by column and direction
        .orderBy(['attributes.tier_alias'], ['asc'])
        .value()
    },

    datacenterNetworkImageGroups: function () {
      return _.chain(this.image_groups)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_tier_id == 5
        })
        // Filter by wan path count
        .filter(function (item) {
          return item.attributes.group_wan_path_count == this.topology_blueprint.attributes.blueprint_wan_path_count
        }.bind(this))
        // Order by column and direction
        .orderBy(['attributes.group_display_order'], ['asc'])
        .value()
    },

    datacenterOptimization: function () {
      return this.imageGroupByTier(6)
    },

    datacenterOptimizationImage: function () {
      return this.diagramImage(
        this.datacenterOptimization
      )
    },

    datacenterOptimizationImageGroups: function () {
      return _.chain(this.image_groups)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_tier_id == 6
        })
        // Filter by wan path count
        .filter(function (item) {
          return item.attributes.group_lan_path_count == this.datacenterNetwork.attributes.group_lan_path_count
        }.bind(this))
        // Order by column and direction
        .orderBy(['attributes.group_display_order'], ['asc'])
        .value()
    },

    datacenterHostImageGroups: function () {
      return _.chain(this.image_groups)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_tier_id == 7
        })
        // Order by column and direction
        .orderBy(['attributes.group_display_order'], ['asc'])
        .value()
    },
  }
}
</script>
